import api from './axios';
import { PickupType } from './students';

/**
 * Registered student information from family registration
 */
export interface RegisteredStudent {
  id: number;
  first_name: string;
  last_name: string;
  grade: string;
  pickup_type: PickupType;
  medical_notes: string | null;
  family: {
    id: number;
    family_name: string;
  };
}

/**
 * Authorized person who can pick up a student
 */
export interface AuthorizedPerson {
  id: number;
  first_name: string;
  last_name: string;
  relationship: string;
  phone: string;
  has_pickup_rights: boolean;
  id_check_required: boolean;
}

/**
 * Response from authorized persons lookup endpoint
 */
export interface AuthorizedPersonsResponse {
  student: {
    id: number;
    first_name: string;
    last_name: string;
    grade: string;
    medical_notes: string | null;
  };
  family: {
    id: number;
    family_name: string;
  };
  authorized_persons: AuthorizedPerson[];
}

/**
 * Search for registered students by name (staff/admin only)
 * @param searchQuery - Name to search for
 * @returns Array of registered students with family info
 */
export const searchRegisteredStudents = async (
  searchQuery: string
): Promise<RegisteredStudent[]> => {
  console.debug('[api] Searching registered students', { query: searchQuery });
  const { data } = await api.get<{ students: RegisteredStudent[] }>(
    '/api/staff/students/search',
    {
      params: { q: searchQuery },
    }
  );
  console.debug('[api] Search results', { count: data.students.length });
  return data.students;
};

/**
 * Get authorized pickup persons for a specific student (staff/admin only)
 * @param studentId - Registered student ID
 * @returns Student info, family info, and list of authorized persons
 */
export const getAuthorizedPersons = async (
  studentId: number
): Promise<AuthorizedPersonsResponse> => {
  console.debug('[api] Fetching authorized persons', { studentId });
  const { data } = await api.get<AuthorizedPersonsResponse>(
    `/api/staff/students/${studentId}/authorized-persons`
  );
  console.debug('[api] Authorized persons retrieved', {
    count: data.authorized_persons.length,
  });
  return data;
};
